(function() {
  'use strict';

  angular
    .module('worldChristianAudio', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'angularUtils.directives.dirPagination',
      'ngPassword',
      'vcRecaptcha',
      'oitozero.ngSweetAlert'
    ]);
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('SearchController', SearchController)

  function SearchController($state) {
    var vm = this;

    vm.submitSearch = submitSearch;

    function submitSearch(){
      $state.go('root.search', {'q': vm.query});
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('ResultsController', ResultsController)

  function ResultsController(SearchResults) {
    var vm = this;

    vm.results = SearchResults.data;
    vm.query = vm.results.query;
    vm.resultCount = vm.results.audio.length + vm.results.organizations.length + vm.results.languages.length + vm.results.countries.length;
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('SearchFactory', SearchFactory);

  function SearchFactory($http){
    var service = {
      getSearchResults: getSearchResults
    }

    return service;

    //////////////

    function getSearchResults(query){
      return $http({
        url: 'api/search?q=' + query,
        method: 'GET'
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('OrganizationFactory', OrganizationFactory);

  function OrganizationFactory($http){
    var service = {
      getAllData: getAllData,
      getByLetter: getByLetter,
      getByID: getByID
    }

    return service;

    //////////////

    function getAllData(){
      return $http({
        url: 'api/organizations/',
        method: 'GET'
      });
    }

    function getByLetter(letter){
      return $http({
        url: 'api/organizations?letter=' + letter,
        method: 'GET'
      });
    }

    function getByID(id){
      return $http({
        url: 'api/organizations?id=' + id,
        method: 'GET'
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('PageController', PageController)

  function PageController($stateParams) {
    var vm = this;
    vm.pageText = $stateParams.pageText;
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('MainController', MainController)

  function MainController(PageHeadings, FaqList, $injector) {
    var vm = this;

    vm.$state = $injector.get('$state');

    vm.faqList = FaqList.data;
    vm.headings = PageHeadings.data;

    vm.headingCount = 0;

    if(vm.headings.length == 0) {
      vm.headings.push({
        page_index: '1',
        page_title: 'Home',
        active: 'Y'
      });
    }

    vm.headings.push({
      page_index: '10',
      page_title: 'Contact',
      active: 'Y'
    });

    angular.forEach(vm.headings, function(value){
      vm.headingCount += value.active == 'Y' ? 1 : 0;
    });

    vm.leftover = 12 % vm.headingCount;

    if (vm.leftover == 0) {
      vm.columnWidth = 12 / vm.headingCount;
    } else {
      vm.columnWidth = Math.floor(12 / vm.headingCount);

      if (vm.leftover % 2 == 0) {
        vm.spacer = vm.leftover / 2;
      } else {
        vm.spacer = Math.floor(vm.leftover / 2);
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('ListController', ListController)

  function ListController(ItemList, $stateParams) {
    var vm = this;

    vm.alphabet = "All,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,123".split(",");
    vm.itemList = ItemList.data;
    vm.activeLetter = $stateParams.q;
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('DetailsController', DetailsController)

  function DetailsController(ItemDetails) {
    var vm = this;
    vm.itemDetails = ItemDetails.data;
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('MainFactory', MainFactory);

  function MainFactory($http){
    var service = {
      getHeadings: getHeadings,
      getFaqs: getFaqs
    }

    return service;

    //////////////

    function getHeadings(){
      return $http({
        url: 'api/headings/',
        method: 'GET'
      });
    }

    function getFaqs(){
      return $http({
        url: 'api/faqs/',
        method: 'GET'
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('LanguageFactory', LanguageFactory);

  function LanguageFactory($http){
    var service = {
      getAllData: getAllData,
      getByLetter: getByLetter,
      getByID: getByID
    }

    return service;

    //////////////

    function getAllData(){
      return $http({
        url: 'api/languages/',
        method: 'GET'
      });
    }

    function getByLetter(letter){
      return $http({
        url: 'api/languages?letter=' + letter,
        method: 'GET'
      });
    }

    function getByID(id){
      return $http({
        url: 'api/languages?id=' + id,
        method: 'GET'
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('CountryFactory', CountryFactory);

  function CountryFactory($http){
    var service = {
      getAllData: getAllData,
      getByLetter: getByLetter,
      getByID: getByID
    }

    return service;

    //////////////

    function getAllData(){
      return $http({
        url: 'api/countries/',
        method: 'GET'
      });
    }

    function getByLetter(letter){
      return $http({
        url: 'api/countries?letter=' + letter,
        method: 'GET'
      });
    }

    function getByID(id){
      return $http({
        url: 'api/countries?name=' + id,
        method: 'GET'
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .controller('ContactController', ContactController)

  function ContactController(ContactFactory, $scope, $timeout, CheckMessage, SweetAlert, $state) {
    var vm = this;

    vm.sending = false;

    if (CheckMessage) {
      vm.checkMessage = CheckMessage.data;
    } else {
      vm.checkMessage = {
        originalMessage: {},
        replies: []
      };
    }

    vm.formData = {
      name: '',
      email: '',
      message: '',
      recaptchaResponse: ''
    }

    vm.replyData = {
      name: vm.checkMessage.originalMessage.cu_name,
      idx: vm.checkMessage.originalMessage.cu_index,
      vs: vm.checkMessage.originalMessage.cu_verify,
      email: vm.checkMessage.originalMessage.cu_email,
      reply: '',
      recaptchaResponse: ''
    }

    ///////////

    vm.submitContact = submitContact;
    vm.submitReply = submitReply;
    vm.recaptchaResponse = recaptchaResponse;
    vm.recaptchaExpire = recaptchaExpire;

    ///////////

    function submitContact(){
      if( !$scope.contactForm.$invalid ) {
        vm.sending = true;

        var submit = ContactFactory.submitContact(vm.formData);

        submit.then(function success(response){
          var IDX = response.data.IDX;
          var VS = response.data.VS;

          SweetAlert.swal({
            title: "Message Sent",
            text: "Your message has been sent. Thank you!",
            type: "success"
          },
            function(){
              $state.go('root.Contact', {'IDX': IDX, 'VS': VS}, {reload: true, inherit: false, notify: true});
            });
          }, function error(){
            SweetAlert.swal("Message Not Sent", "Error sending message. Try again later!", "error");
            vm.sending = false;
          });
      }
    }

    function submitReply(){
      if( !$scope.replyForm.$invalid ) {
        vm.sending = true;
        var submit = ContactFactory.submitReply(vm.replyData);

        submit.then(function success(){
          SweetAlert.swal({
            title: "Message Sent",
            text: "Your message has been sent. Thank you!",
            type: "success"
          },
            function(){
              $state.reload();
            });
          }, function error(){
            SweetAlert.swal("Message Not Sent", "Error sending message. Try again later!", "error");
            vm.sending = false;
          });
      }
    }

    function recaptchaResponse(response){
      $timeout(function(){
        vm.formData.recaptchaResponse = response;
        vm.replyData.recaptchaResponse = response;
      });
    }

    function recaptchaExpire(){
      $timeout(function(){
        vm.formData.recaptchaResponse = '';
        vm.replyData.recaptchaResponse = '';
      });
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('ContactFactory', ContactFactory);

  function ContactFactory($http){
    var service = {
      checkMessage: checkMessage,
      submitContact: submitContact,
      submitReply: submitReply
    }

    return service;

    //////////////

    function submitContact(postData){
      return $http({
        url: 'api/contact/',
        method: 'POST',
        data: postData
      });
    }

    function submitReply(postData){
      return $http({
        url: 'api/contact/',
        method: 'PUT',
        data: postData
      });
    }

    function checkMessage(messageData){
      return $http({
        url: 'api/contact?IDX=' + messageData.IDX + '&VS=' + messageData.VS,
        method: 'GET',
        data: messageData
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('worldChristianAudio')
    .factory('AudioFactory', AudioFactory);

  function AudioFactory($http){
    var service = {
      getAllData: getAllData,
      getByLetter: getByLetter,
      getByID: getByID
    }

    return service;

    //////////////

    function getAllData(){
      return $http({
        url: 'api/audio/',
        method: 'GET'
      });
    }

    function getByLetter(letter){
      return $http({
        url: 'api/audio?letter=' + letter,
        method: 'GET'
      });
    }

    function getByID(id){
      return $http({
        url: 'api/audio?id=' + id,
        method: 'GET'
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('worldChristianAudio')
    .run(runBlock);

  /** @ngInject */
  function runBlock($stateRegistry, $state, $http, $rootScope, $urlRouter, $transitions, $trace, $location) {
    var vm = {};

    vm.statePageMapping = [];
    vm.statePageMapping[1] = {'name': 'home'};
    vm.statePageMapping[2] = {'name': 'about'};
    vm.statePageMapping[3] = {'name': 'vision'};
    vm.statePageMapping[4] = {'name': 'faq'};
    vm.statePageMapping[5] = {'name': 'links'};
    vm.statePageMapping[6] = {'name': 'submit'};
    vm.statePageMapping[7] = {'name': 'seven'};
    vm.statePageMapping[8] = {'name': 'eight'};
    vm.statePageMapping[9] = {'name': 'nine'};
    vm.statePageMapping[10] = {'name': 'contact'};

    createStates().then(function(){
      $urlRouter.sync();
      $urlRouter.listen();
    });

    function createStates(){
      var setupStates = $http.get('/api/headings').success(function(data){
        if(data.length > 0) {
          angular.forEach(data, function (value){
            if(value.active == 'Y' && value.page_index >= 1) {
              var pageURL = vm.statePageMapping[value.page_index].name == 'home' ? '/' : '/' + vm.statePageMapping[value.page_index].name;

              var state = {
                name: 'root.' + value.page_title,
                url: pageURL,
                controller: 'PageController as page',
                params: {
                  pageText: value.page_text
                }
              };

              if (vm.statePageMapping[value.page_index].name != 'faq') {
                state.templateUrl = 'app/main/page.html';
              } else {
                state.templateUrl = 'app/faq/faq.html';
              }

              vm.statePageMapping[value.page_index].stateName = value.page_title;

              $stateRegistry.register(state);
            }
          });
        } else {
          var state = {
            name: 'root.Home',
            url: '/',
            controller: 'PageController as page',
            templateUrl: 'app/main/page.html',
            params: {
              pageText: 'The World Christian Audio Directory is an attempt to list what audio recordings in around 1000 languages. Thousands of titles of Christian audio recordings from around the world are listed with a description and where to buy them.'
            }
          };

          vm.statePageMapping[1].stateName = 'Home';

          $stateRegistry.register(state);
        }

      });

      return setupStates;
    }

    $transitions.onBefore({ to:'root.otherwise' }, function() {
      // the state is matched to the URL before the dynamic states are loaded...
      // so before the state changes to the 404 state, we need to double check to make sure the requested state is valid or not

      // we're going to use the path to match against the vm.statePageMapping object

      var path = $location.$$path.replace(/\//g, "");
      var matched = false;
      var stateName = '';

      angular.forEach(vm.statePageMapping, function(value){
        if(value.name == path || (value.name == 'home' && path == '')) {
          matched = true;
          stateName = 'root.' + value.stateName;
        }
      })

      if (matched) {
        $state.go(stateName);
        return false;
      } else {
        return true;
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('worldChristianAudio')
    .config(routerConfig);

  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $urlMatcherFactoryProvider) {
    $locationProvider.html5Mode(true);
    $urlMatcherFactoryProvider.strictMode(false)

    $urlRouterProvider.deferIntercept();

    $stateProvider
      .state('root', {
        abstract: true,
        templateUrl: 'app/main/main.html',
        controller: 'MainController as main',
        resolve: {
          PageHeadings: function(MainFactory){
            return MainFactory.getHeadings()
          },
          FaqList: function(MainFactory){
            return MainFactory.getFaqs()
          }
        }
      })
      .state('root.audioList', {
        url: '/audio/list?q',
        templateUrl: 'app/audio/list.html',
        controller: 'ListController as audioList',
        resolve: {
          ItemList: function($stateParams, AudioFactory){
            if (typeof $stateParams.q == 'undefined') {
              return {data: []};
            } else if($stateParams.q == 'All') {
              return AudioFactory.getAllData();
            } else {
              return AudioFactory.getByLetter($stateParams.q);
            }
          }
        }
      })
      .state('root.audioDetail', {
        url: '/audio/detail?id',
        templateUrl: 'app/audio/detail.html',
        controller: 'DetailsController as audioDetails',
        resolve: {
          ItemDetails: function($stateParams, AudioFactory){
            if (typeof $stateParams.id == 'undefined') {
              return {data: []};
            } else {
              return AudioFactory.getByID($stateParams.id);
            }
          }
        }
      })
      .state('root.organizationList', {
        url: '/organization/list?q',
        templateUrl: 'app/organization/list.html',
        controller: 'ListController as organizationList',
        resolve: {
          ItemList: function($stateParams, OrganizationFactory){
            if (typeof $stateParams.q == 'undefined') {
              return {data: []};
            } else if($stateParams.q == 'All') {
              return OrganizationFactory.getAllData();
            } else {
              return OrganizationFactory.getByLetter($stateParams.q);
            }
          }
        }
      })
      .state('root.organizationDetail', {
        url: '/organizations/detail?id',
        templateUrl: 'app/organization/detail.html',
        controller: 'DetailsController as organizationDetails',
        resolve: {
          ItemDetails: function($stateParams, OrganizationFactory){
            if (typeof $stateParams.id == 'undefined') {
              return {data: []};
            } else {
              return OrganizationFactory.getByID($stateParams.id);
            }
          }
        }
      })
      .state('root.languageList', {
        url: '/language/list?q',
        templateUrl: 'app/language/list.html',
        controller: 'ListController as languageList',
        resolve: {
          ItemList: function($stateParams, LanguageFactory){
            if (typeof $stateParams.q == 'undefined') {
              return {data: []};
            } else if($stateParams.q == 'All') {
              return LanguageFactory.getAllData();
            } else {
              return LanguageFactory.getByLetter($stateParams.q);
            }
          }
        }
      })
      .state('root.languageDetail', {
        url: '/languages/detail?id',
        templateUrl: 'app/language/detail.html',
        controller: 'DetailsController as languageDetails',
        resolve: {
          ItemDetails: function($stateParams, LanguageFactory){
            if (typeof $stateParams.id == 'undefined') {
              return {data: []};
            } else {
              return LanguageFactory.getByID($stateParams.id);
            }
          }
        }
      })
      .state('root.countryList', {
        url: '/country/list?q',
        templateUrl: 'app/country/list.html',
        controller: 'ListController as countryList',
        resolve: {
          ItemList: function($stateParams, CountryFactory){
            if (typeof $stateParams.q == 'undefined') {
              return {data: []};
            } else if($stateParams.q == 'All') {
              return CountryFactory.getAllData();
            } else {
              return CountryFactory.getByLetter($stateParams.q);
            }
          }
        }
      })
      .state('root.countryDetail', {
        url: '/country/detail?name',
        templateUrl: 'app/country/detail.html',
        controller: 'DetailsController as countryDetails',
        resolve: {
          ItemDetails: function($stateParams, CountryFactory){
            if (typeof $stateParams.name == 'undefined') {
              return {data: []};
            } else {
              return CountryFactory.getByID($stateParams.name);
            }
          }
        }
      })
      .state('root.search', {
        url: '/search?q',
        templateUrl: 'app/search/results.html',
        controller: 'ResultsController as search',
        resolve: {
          SearchResults: function(SearchFactory, $stateParams){
            return SearchFactory.getSearchResults($stateParams.q);
          }
        }
      })
      .state('root.Contact', {
        url: '/contact?idx&vs&IDX&VS',
        templateUrl: 'app/contact/contact.html',
        controller: 'ContactController as contact',
        resolve: {
          CheckMessage: function(ContactFactory, $stateParams){
            if ($stateParams.IDX && $stateParams.VS) {
              return ContactFactory.checkMessage($stateParams);
            } else {
              return null;
            }
          }
        }
      })
      .state('root.otherwise', {
        url: '/*path',
        data: { pageTitle: 'Page Not Found' },
        templateUrl: 'app/main/404.html'
      });
  }

})();

angular.module("worldChristianAudio").run(["$templateCache", function($templateCache) {$templateCache.put("app/audio/detail.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"text-center\"><h3>{{audioDetails.itemDetails.vt_title}}</h3></div><hr class=\"hidden-lg hidden-md\"><div class=\"row text-center\"><div class=\"col-md-6\"><h5><strong>Organization(s) that sell this Audio:</strong></h5><div ng-repeat=\"organization in audioDetails.itemDetails.org\" class=\"m-b\"><strong><a ui-sref=\"root.organizationDetail({\'id\': organization.org_index})\">{{organization.org_title}}</a></strong><br><div ng-repeat=\"website in organization.web\"><a href=\"http://{{website.web_address}}\" target=\"_blank\">{{website.web_address}}</a></div></div></div><hr class=\"hidden-lg hidden-md\"><div class=\"col-md-6\"><h5><strong>Available in the following languages:</strong></h5><p class=\"no-margins\" ng-repeat=\"language in audioDetails.itemDetails.lang\"><a ui-sref=\"root.languageDetail({\'id\': language.lang_index})\">{{language.lang_desc}}</a></p></div></div>");
$templateCache.put("app/audio/list.html","<div><div ng-include=\"\'app/listing/bar.html\'\"></div><hr><nav class=\"text-center\"><ul class=\"pagination\"><li ng-repeat=\"letter in audioList.alphabet\" ng-class=\"{\'active\': letter == audioList.activeLetter}\" class=\"btn-primary\"><a ui-sref=\"root.audioList({\'q\': letter})\">{{letter}}</a></li></ul></nav><div class=\"row\"><div class=\"col-lg-6\" ng-repeat=\"value in audioList.itemList\"><a ui-sref=\"root.audioDetail({\'id\': value.vt_index})\">{{value.vt_title}}</a></div></div></div>");
$templateCache.put("app/contact/contact.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div ng-show=\"contact.checkMessage.originalMessage.cu_index == null\"><div class=\"row\"><div class=\"col-lg-3\"></div><div class=\"col-lg-6\"><h3>Contact Us:</h3><form class=\"form\" role=\"form\" name=\"contactForm\" ng-submit=\"contact.submitContact()\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': contactForm.name.$invalid && contactForm.$submitted}\"><input class=\"form-control\" type=\"text\" name=\"name\" placeholder=\"Name\" ng-model=\"contact.formData.name\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': contactForm.email.$invalid && contactForm.$submitted}\"><input class=\"form-control\" type=\"email\" name=\"email\" placeholder=\"Email Address\" ng-model=\"contact.formData.email\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': contactForm.message.$invalid && contactForm.$submitted}\"><textarea class=\"form-control\" rows=\"5\" name=\"message\" placeholder=\"Question/Comment\" ng-model=\"contact.formData.message\" required=\"\"></textarea></div><div class=\"m-b\"><div vc-recaptcha=\"\" key=\"\'6Lee7CsUAAAAAAjvTRINjBOyixaaTtWiFEA_4TK3\'\" on-success=\"contact.recaptchaResponse(response)\"></div></div><div class=\"m-b\" ng-messages=\"contactForm.$error\" ng-show=\"contactForm.$submitted\"><div ng-message=\"required\" class=\"text-danger text-center m-t\">Required fields are missing.</div><div ng-message=\"email\" class=\"text-danger text-center m-t\">Email address is not valid.</div></div><div class=\"form-group text-center\"><button class=\"btn btn-warning\" type=\"submit\" ng-disabled=\"contact.formData.recaptchaResponse == \'\' || contact.sending == true\">Send Message</button></div></form></div><div class=\"col-lg-3\"></div></div></div><div ng-show=\"contact.checkMessage.originalMessage.cu_index != null\"><div class=\"row\"><div class=\"col-lg-3\"></div><div class=\"col-lg-6\"><h3>Contact Us:</h3><table class=\"table table-bordered\"><tr><th class=\"text-right\" width=\"25%\">Name</th><td>{{contact.checkMessage.originalMessage.cu_name}}</td></tr><tr><th class=\"text-right\" width=\"25%\">Email</th><td><a href=\"mailto:{{contact.checkMessage.originalMessage.cu_email}}\" target=\"_blank\">{{contact.checkMessage.originalMessage.cu_email}}</a></td></tr><tr><th class=\"text-right\" width=\"25%\">Entry Date</th><td>{{contact.checkMessage.originalMessage.cu_date}}</td></tr><tr><th class=\"text-right\" width=\"25%\">Message</th><td ng-bind-html=\"contact.checkMessage.originalMessage.cu_text\"></td></tr></table><hr><div ng-repeat=\"message in contact.checkMessage.replies\"><table class=\"table table-bordered\"><tr ng-if=\"message.reply_who == \'A\'\"><th class=\"text-right\" width=\"25%\">Name</th><td>Tract Finder Admin</td></tr><tr ng-if=\"message.reply_who == \'B\'\"><th class=\"text-right\" width=\"25%\">Name</th><td>{{contact.checkMessage.originalMessage.cu_name}}</td></tr><tr ng-if=\"message.reply_who == \'B\'\"><th class=\"text-right\" width=\"25%\">Email</th><td>{{contact.checkMessage.originalMessage.cu_email}}</td></tr><tr><th class=\"text-right\" width=\"25%\">Entry Date</th><td>{{message.reply_date}}</td></tr><tr><th class=\"text-right\" width=\"25%\">Message</th><td ng-bind-html=\"message.reply_text\"></td></tr></table><hr></div><form class=\"form\" role=\"form\" name=\"replyForm\" ng-submit=\"contact.submitReply()\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': replyForm.reply.$invalid && replyForm.$submitted}\"><textarea class=\"form-control\" rows=\"5\" name=\"reply\" placeholder=\"Send Another Question/Comment...\" ng-model=\"contact.replyData.reply\" required=\"\"></textarea></div><div class=\"m-b\"><div vc-recaptcha=\"\" key=\"\'6Le64SkUAAAAAHUcOQ_pNZ-Lp-Ky9lg3gvrgKKm_\'\" on-success=\"contact.recaptchaResponse(response)\"></div></div><div class=\"m-b\" ng-messages=\"replyForm.$error\" ng-show=\"replyForm.$submitted\"><div ng-message=\"required\" class=\"text-danger text-center m-t\">Required fields are missing.</div></div><div class=\"form-group text-center\"><button class=\"btn btn-warning\" type=\"submit\" ng-disabled=\"contact.replyData.recaptchaResponse == \'\' || contact.sending == true\">Send Reply</button></div></form></div><div class=\"col-lg-3\"></div></div></div>");
$templateCache.put("app/country/detail.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"text-center\"><h3>{{countryDetails.itemDetails.country}}</h3><p><strong>Organizations in this country:</strong></p></div><p class=\"row\" ng-show=\"countryDetails.itemDetails.organizations.length == 0\">None.</p><div class=\"row\" ng-show=\"countryDetails.itemDetails.organizations.length > 0\"><div class=\"col-lg-6\" ng-repeat=\"organization in countryDetails.itemDetails.organizations\"><a ui-sref=\"root.organizationDetail({\'id\': organization.org_index})\">{{organization.org_title}}</a></div></div>");
$templateCache.put("app/country/list.html","<div><div ng-include=\"\'app/listing/bar.html\'\"></div><hr><nav class=\"text-center\"><ul class=\"pagination\"><li ng-repeat=\"letter in countryList.alphabet\" ng-class=\"{\'active\': letter == countryList.activeLetter}\" class=\"btn-primary\"><a ui-sref=\"root.countryList({\'q\': letter})\">{{letter}}</a></li></ul></nav><div class=\"row\"><div class=\"col-lg-6\"><div ng-show=\"$index % 2 == 0\" ng-repeat=\"value in countryList.itemList\"><a ui-sref=\"root.countryDetail({\'name\': value.country})\"><strong>{{value.country}}</strong></a><ol><li ng-repeat=\"organization in value.organizations\"><a ui-sref=\"root.organizationDetail({\'id\': organization.org_index})\">{{organization.org_title}}</a></li></ol></div></div><div class=\"col-lg-6\"><div ng-show=\"$index % 2 == 1\" ng-repeat=\"value in countryList.itemList\"><a ui-sref=\"root.countryDetail({\'name\': value.country})\"><strong>{{value.country}}</strong></a><ol><li ng-repeat=\"organization in value.organizations\"><a ui-sref=\"root.organizationDetail({\'id\': organization.org_index})\">{{organization.org_title}}</a></li></ol></div></div></div></div>");
$templateCache.put("app/faq/faq.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"row\"><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div><div class=\"col-sm-12 col-md-8\">{{page.pageText}}</div><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div></div><hr><h4>Frequently Asked Questions</h4><ol><li ng-repeat=\"faq in main.faqList\"><strong>{{faq.faq_question}}</strong><br>{{faq.faq_answer}}<br><br></li></ol>");
$templateCache.put("app/language/detail.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"text-center\"><h3>{{languageDetails.itemDetails.lang_desc}}</h3><p><strong>Audio in this language:</strong></p></div><div class=\"row\" ng-show=\"languageDetails.itemDetails.audio.length > 0\"><div class=\"col-lg-6\" ng-repeat=\"audio in languageDetails.itemDetails.audio\"><a ui-sref=\"root.audioDetail({\'id\': audio.vt_index})\">{{audio.vt_title}}</a></div></div>");
$templateCache.put("app/language/list.html","<div><div ng-include=\"\'app/listing/bar.html\'\"></div><hr><nav class=\"text-center\"><ul class=\"pagination\"><li ng-repeat=\"letter in languageList.alphabet\" ng-class=\"{\'active\': letter == languageList.activeLetter}\" class=\"btn-primary\"><a ui-sref=\"root.languageList({\'q\': letter})\">{{letter}}</a></li></ul></nav><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-6\" ng-repeat=\"value in languageList.itemList\"><a ui-sref=\"root.languageDetail({\'id\': value.lang_index})\">{{value.lang_desc}}</a></div></div></div>");
$templateCache.put("app/listing/bar.html","<div class=\"row text-center\"><div class=\"col-lg-6\"><div ng-include=\"\'app/search/search.html\'\"></div></div><hr class=\"hidden-lg\"><div class=\"col-lg-6\"><p>View alphabetical listing of database by...</p><nav><ul class=\"pagination no-margins\"><li ng-class=\"{active: main.$state.current.name.indexOf(\'audio\') >= 0}\"><a ui-sref=\"root.audioList\">Audio Title</a></li><li ng-class=\"{active: main.$state.current.name.indexOf(\'organization\') >= 0}\"><a ui-sref=\"root.organizationList\">Organization</a></li><li ng-class=\"{active: main.$state.current.name.indexOf(\'language\') >= 0}\"><a ui-sref=\"root.languageList\">Language</a></li><li ng-class=\"{active: main.$state.current.name.indexOf(\'country\') >= 0}\"><a ui-sref=\"root.countryList\">Country</a></li></ul></nav></div></div>");
$templateCache.put("app/listing/listing.html","<div class=\"row\"><div class=\"col-lg-12\"><ul><li><a ui-sref=\"root.videoList\">Tract</a> - Alphabetical Listing of All Titles of Tracts</li><li><a ui-sref=\"root.organizationList\">Organization</a> - Alphabetical Listing of All Organizations/Distributors/Resellers which sell Tracts</li><li><a ui-sref=\"root.languageList\">Language</a> - Alphabetical Listing of All Languages Of Tracts</li><li><a ui-sref=\"root.countryList\">Country</a> - Alphabetical Listing of All Countries of All Organizations/Distributors/Resellers</li></ul></div></div>");
$templateCache.put("app/main/404.html","<div class=\"middle-box text-center\"><h1>404</h1><h3 class=\"font-bold\">Page Not Found</h3><div class=\"error-desc\">Sorry, but the page you are looking for was not found.</div></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div class=\"text-center\"><img src=\"/assets/images/world-christian-audio-banner.jpg\" class=\"hidden-xs\" alt=\"World Christian Audio Directory: A database of Christian audio titles available in various languages.\" width=\"100%\"></div><div class=\"row text-center hidden-xs m-t-md\" ng-show=\"main.columnWidth > 1\"><div class=\"col-sm-{{main.spacer}}\" ng-show=\"main.spacer > 0\">&nbsp;</div><div class=\"col-sm-{{main.columnWidth}}\" ng-repeat=\"heading in main.headings | filter:{\'active\' : \'Y\'}\"><button class=\"btn btn-default btn-sm btn-block\" ui-sref=\"root.{{heading.page_title}}\" ui-sref-active=\"btn-drkblue\">{{heading.page_title}}</button></div><div class=\"col-sm-{{main.spacer}}\" ng-show=\"main.spacer > 0\">&nbsp;</div></div><nav class=\"navbar navbar-default visible-xs\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#main-navbar-collapse\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand visible-xs\" href=\"#\">World Christian Audio Directory</a></div><div class=\"collapse navbar-collapse\" id=\"main-navbar-collapse\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"heading in main.headings | filter:{active: \'Y\'}\" ui-sref-active=\"active\"><a ui-sref=\"root.{{heading.page_title}}\">{{heading.page_title}}</a></li></ul></div></div></nav><p class=\"lead visible-xs\">Helping you to reach the world for Jesus.</p><hr><div ui-view=\"\"></div><hr><div class=\"row\"><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div><div class=\"col-sm-12 col-md-8\"><p>This is an information site, not a retail site. If you have any questions or need help finding a particular video, DVD, tract, book or any other Christian resource in any language of the world, please contact <a href=\"mailto:brianformissions@gmail.com\" target=\"_blank\">brianformissions@gmail.com</a></p></div><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div></div><hr><div class=\"text-center\"><div id=\"google_translate_element\"></div></div></div>");
$templateCache.put("app/main/page.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"row\"><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div><div class=\"col-sm-12 col-md-8\" ng-bind-html=\"page.pageText\"></div><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div></div>");
$templateCache.put("app/organization/detail.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><div class=\"text-center\"><h3>{{organizationDetails.itemDetails.org_title}}</h3><p ng-bind-html=\"organizationDetails.itemDetails.org_desc\"></p><p ng-show=\"website.web_address != \'X\'\" ng-repeat=\"website in organizationDetails.itemDetails.web\"><a href=\"http://{{website.web_address}}\" target=\"_blank\">{{website.web_address}}</a></p></div><hr><div class=\"row text-center\"><div class=\"col-lg-4\"><p><strong>Address</strong></p><p ng-show=\"organizationDetails.itemDetails.address.length == 0\">None</p><div ng-repeat=\"address in organizationDetails.itemDetails.address\" ng-show=\"organizationDetails.itemDetails.address.length > 0\"><address><div ng-show=\"address.street_address != \'\' && address.street_address != \'X\'\">{{address.street_address}}</div><div ng-show=\"address.street_address2 != \'\'\">{{address.street_address2}}</div><span ng-show=\"address.city != \'\'\">{{address.city}}</span> <span ng-show=\"address.state != \'\'\">{{address.state}}</span> <span ng-show=\"address.zip != \'\'\">{{address.zip}}</span><div ng-show=\"address.country != \'\'\">{{address.country}}</div></address></div></div><div class=\"col-lg-4\"><p><strong>Phone</strong></p><p ng-show=\"organizationDetails.itemDetails.phone.length == 0\">None</p><div ng-repeat=\"phone in organizationDetails.itemDetails.phone\" ng-show=\"organizationDetails.itemDetails.phone.length > 0\"><p>{{phone.phone_number}}</p></div></div><div class=\"col-lg-4\"><p><strong>Email</strong></p><p ng-show=\"organizationDetails.itemDetails.email.length == 0\">None</p><div ng-repeat=\"email in organizationDetails.itemDetails.email\" ng-show=\"organizationDetails.itemDetails.email.length > 0\"><p><a href=\"mailto:{{email.email_address}}\" target=\"_blank\">{{email.email_address}}</a></p></div></div></div><hr><div class=\"text-center\"><h4>Audio offered by this organization:</h4></div><div class=\"text-center\" ng-show=\"organizationDetails.itemDetails.audio.length == 0\"><p>None</p></div><div class=\"row\" ng-show=\"organizationDetails.itemDetails.audio.length > 0\"><div class=\"col-lg-6\" ng-repeat=\"audio in organizationDetails.itemDetails.audio\"><a ui-sref=\"root.audioDetail({\'id\': audio.vt_index})\">{{audio.vt_title}}</a></div></div>");
$templateCache.put("app/organization/list.html","<div><div ng-include=\"\'app/listing/bar.html\'\"></div><hr><nav class=\"text-center\"><ul class=\"pagination\"><li ng-repeat=\"letter in organizationList.alphabet\" ng-class=\"{\'active\': letter == organizationList.activeLetter}\" class=\"btn-primary\"><a ui-sref=\"root.organizationList({\'q\': letter})\">{{letter}}</a></li></ul></nav><div class=\"row\"><div class=\"col-lg-6\" ng-repeat=\"value in organizationList.itemList\"><a ui-sref=\"root.organizationDetail({\'id\': value.org_index})\">{{value.org_title}}</a></div></div></div>");
$templateCache.put("app/search/results.html","<div ng-include=\"\'app/listing/bar.html\'\"></div><hr><h4>Search results for <strong>{{search.query}}</strong> ({{search.resultCount}} results):</h4><table class=\"table table-hover table-striped cards middle-align\"><thead><tr><th width=\"5%\">Type</th><th width=\"35%\">Name</th><th>Description</th></tr></thead><tbody><tr ng-repeat=\"item in search.results.audio\"><td><span class=\"card-heading\">Type:</span>{{item.type}}</td><td><span class=\"card-heading\">Name:</span><a ui-sref=\"root.audioDetail({\'id\': item.index})\">{{item.name}}</a></td><td><span class=\"card-heading\">Description:</span>{{item.desc}}</td></tr><tr ng-repeat=\"item in search.results.organizations\"><td><span class=\"card-heading\">Type:</span>{{item.type}}</td><td><span class=\"card-heading\">Name:</span><a ui-sref=\"root.organizationDetail({\'id\': item.index})\">{{item.name}}</a></td><td><span class=\"card-heading\">Description:</span>{{item.desc}}</td></tr><tr ng-repeat=\"item in search.results.languages\"><td><span class=\"card-heading\">Type:</span>{{item.type}}</td><td><span class=\"card-heading\">Name:</span><a ui-sref=\"root.languageDetail({\'id\': item.index})\">{{item.name}}</a></td><td><span class=\"card-heading\">Description:</span>{{item.desc}}</td></tr><tr ng-repeat=\"item in search.results.countries\"><td><span class=\"card-heading\">Type:</span>{{item.type}}</td><td><span class=\"card-heading\">Name:</span><a ui-sref=\"root.countryDetail({\'id\': item.index})\">{{item.name}}</a></td><td><span class=\"card-heading\">Description:</span>{{item.desc}}</td></tr></tbody></table>");
$templateCache.put("app/search/search.html","<div ng-controller=\"SearchController as search\" class=\"text-center\"><p>Search by keyword...</p><form class=\"form-inline\" ng-submit=\"search.submitSearch()\"><div class=\"form-group\"><input class=\"form-control\" type=\"text\" placeholder=\"Keyword\" ng-model=\"search.query\"><div class=\"hidden-lg hidden-md\">&nbsp;</div><button class=\"btn btn-success\" type=\"submit\">Search</button></div></form></div>");
$templateCache.put("api/application/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/cache/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/config/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/controllers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/core/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/helpers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/hooks/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/language/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/libraries/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/logs/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/models/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/third_party/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/views/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/core/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/fonts/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/helpers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/language/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/language/english/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/views/errors/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/core/compat/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/language/english/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/Cache/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/Javascript/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/Session/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/views/errors/cli/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/application/views/errors/html/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/cubrid/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/ibase/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/mssql/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/mysql/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/mysqli/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/oci8/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/odbc/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/pdo/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/postgre/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/sqlite/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/sqlite3/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/sqlsrv/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/Cache/drivers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/libraries/Session/drivers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");
$templateCache.put("api/system/database/drivers/pdo/subdrivers/index.html","<!DOCTYPE html><html><head><title>403 Forbidden</title></head><body><p>Directory access is forbidden.</p></body></html>");}]);